// Groove definitions. Drum lines: one char per step ("x" hit, "a" accent, "g" ghost, "." rest).
// Bass: [step, interval|"a"(approach next root), lengthSteps]. Keys/guitar: [step, lengthSteps].
const four = { beats: 4, sub: 4, steps: 16, meter: "4/4" };

export const STYLES = {
  pop: { ...four, label: "Pop",
    drums: { k: "x.......x.x.....", s: "....x.......x...", h: "x.x.x.x.x.x.x.o." },
    fill: { s: "....x.....x.aaaa", h: "x.x.x.x.x......." },
    bass: [[0, 0, 6], [8, 0, 3], [10, 7, 2], [12, 0, 4]],
    keys: [[0, 6], [6, 2], [8, 6], [14, 2]],
    guitar: [[0, 2], [4, 2], [6, 2], [8, 2], [12, 2], [14, 2]] },
  rock: { ...four, label: "Rock",
    drums: { k: "x.....x.x.......", s: "....a.......a...", h: "x.x.x.x.x.x.x.o." },
    fill: { s: "....a.....aaa.a.", t1: "...........x....", t3: ".............x.x" },
    bass: [[0, 0, 2], [2, 0, 2], [4, 0, 2], [6, 0, 2], [8, 0, 2], [10, 0, 2], [12, 0, 2], [14, 7, 2]],
    keys: [[0, 8], [8, 8]],
    guitar: [[0, 2], [2, 2], [4, 2], [6, 2], [8, 2], [10, 2], [12, 2], [14, 2]] },
  funk: { ...four, label: "Funk",
    drums: { k: "x.....x...x..x..", s: "....a..g.g..a..g", h: "x.xxx.xxx.xxx.xo" },
    bass: [[0, 0, 2], [3, 12, 1], [6, 0, 1], [7, 7, 2], [10, 0, 1], [11, 10, 2], [14, 12, 1]],
    keys: [[2, 1], [6, 1], [10, 1], [13, 1]],
    guitar: [[0, 1], [2, 1], [5, 1], [8, 1], [10, 1], [13, 1]] },
  gospel: { ...four, label: "Gospel", swing: 0.25,
    drums: { k: "x......xx.......", s: "....a..g....a.g.", h: "x.x.x.o.x.x.x.o." },
    fill: { s: "....a..g..aa.aaa", t1: "..........x.....", t2: "...........x...." },
    bass: [[0, 0, 4], [6, 7, 2], [8, 0, 4], [14, "a", 2]],
    keys: [[0, 4], [6, 2], [8, 4], [14, 2]],
    guitar: [[2, 1], [6, 1], [10, 1], [14, 1]] },
  shout: { ...four, label: "Gospel shout", swing: 0.55,
    drums: { k: "x...x...x...x...", s: "....a.......a...", h: "x.xxx.xxx.xxx.xx" },
    fill: { s: "....a...aaaaaaaa" },
    bass: [[0, 0, 4], [4, 3, 4], [8, 7, 4], [12, "a", 4]],
    keys: [[0, 2], [4, 2], [8, 2], [12, 2]],
    guitar: [[4, 2], [12, 2]] },
  reggae: { ...four, label: "Reggae one-drop",
    drums: { k: "........x.......", s: "........a.......", h: "x.x.x.x.x.x.x.x." },
    bass: [[0, 0, 3], [4, 7, 2], [6, 0, 2], [10, 12, 2], [12, 7, 4]],
    keys: [[4, 2], [12, 2]],
    guitar: [[4, 1], [12, 1]] },
  bossa: { ...four, label: "Bossa nova",
    drums: { k: "x..x..x.x..x..x.", s: "x..x..x...x..x..", h: "gggggggggggggggg" },
    bass: [[0, 0, 3], [6, 7, 2], [8, 7, 3], [14, 0, 2]],
    keys: [[0, 2], [3, 3], [6, 2], [10, 2], [13, 3]],
    guitar: [[0, 2], [3, 3], [6, 2], [10, 2], [13, 3]] },
  swing: { beats: 4, sub: 2, steps: 8, meter: "4/4", label: "Swing", swing: 0.6,
    drums: { r: "x.xxx.xx", h: "..x...x.", k: "g.g.g.g." },
    bass: [[0, 0, 2], [2, 3, 2], [4, 7, 2], [6, "a", 2]],
    keys: [[0, 2], [3, 1]],
    guitar: [[0, 1], [2, 1], [4, 1], [6, 1]] },
  waltz: { beats: 3, sub: 4, steps: 12, meter: "3/4", label: "Gospel waltz",
    drums: { k: "x...........", s: "....x...x...", h: "x.x.x.x.x.x." },
    bass: [[0, 0, 4], [8, 7, 4]],
    keys: [[4, 3], [8, 3]],
    guitar: [[0, 2], [4, 2], [8, 2]] },
  ballad68: { beats: 2, sub: 3, steps: 6, meter: "6/8", label: "6/8 ballad",
    drums: { k: "x.....", s: "...x..", h: "xgxxgx" },
    bass: [[0, 0, 3], [3, 7, 3]],
    keys: [[0, 3], [3, 3]],
    guitar: [[0, 1], [1, 1], [2, 1], [3, 1], [4, 1], [5, 1]] },
  shuffle12: { beats: 4, sub: 3, steps: 12, meter: "12/8", label: "12/8 shuffle",
    drums: { k: "x.....x.....", s: "...a.....a..", h: "x.xx.xx.xx.x" },
    fill: { s: "...a.....aaa" },
    bass: [[0, 0, 2], [2, 0, 1], [3, 4, 2], [5, 4, 1], [6, 7, 2], [8, 7, 1], [9, 9, 2], [11, 9, 1]],
    keys: [[3, 2], [9, 2]],
    guitar: [[0, 2], [3, 2], [6, 2], [9, 2]] },
  afro68: { beats: 2, sub: 3, steps: 6, meter: "6/8", label: "Afro 6/8 (3 over 2)",
    drums: { r: "x.x.xx", k: "x..x..", s: "..g..x", t1: "....x." },
    bass: [[0, 0, 2], [2, 7, 1], [3, 0, 2], [5, 10, 1]],
    keys: [[0, 2], [2, 2], [4, 2]],
    guitar: [[0, 1], [2, 1], [4, 1]] },
  odd5: { beats: 5, sub: 4, steps: 20, meter: "5/4", label: "5/4 groove",
    drums: { k: "x.....x.....x.......", s: "....x.......x...x...", h: "x.x.x.x.x.x.x.x.x.x." },
    bass: [[0, 0, 6], [6, 7, 2], [12, 0, 4], [16, 7, 4]],
    keys: [[0, 4], [6, 2], [12, 4], [16, 3]],
    guitar: [[0, 2], [4, 2], [8, 2], [12, 2], [16, 2]] },
  odd7: { beats: 3.5, sub: 2, steps: 7, meter: "7/8", label: "7/8 groove (2+2+3)",
    drums: { k: "x...x..", s: "..a..a.", h: "xxxxxxx" },
    bass: [[0, 0, 2], [2, 7, 2], [4, 0, 3]],
    keys: [[0, 2], [4, 3]],
    guitar: [[0, 1], [2, 1], [4, 1], [5, 1]] },
};
